import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import uuid from "uuid";
import { MKPlayer,MKPlayerConfig, MKSourceConfig, MKLogLevel } from "@mediakind/mkplayer";

@Component({
    name: "media-kind-player",
})
export default class MediaKindPlayer extends Vue {
    @Prop({ required: true })
    public streamingUrls: string[];

    public key: string;
    public player: MKPlayer;
    public videoContainer: HTMLElement;
    public playerConfig: MKPlayerConfig;
    public sourceConfig: MKSourceConfig;

    public constructor() {
        super();
        this.key = uuid();
        this.player = null;
    }

    public mounted() {
        this.videoContainer = document.getElementById(`video${this.key}`);
          
        this.playerConfig = {
            key: process.env.VUE_APP_MEDIAKIND_PLAYER_LICENCE_KEY,
            ui: true,
            log: {
                level: MKLogLevel.Off
            },
            playback: {
                muted: false,
                autoplay: false
            }
        };

        this.player = new MKPlayer(this.videoContainer, this.playerConfig);

        this.sourceConfig = {
            hls: this.streamingUrls[0],
            dash: this.streamingUrls[1],
            enableLowLatency: false
        };

        this.player.load(this.sourceConfig)
            .catch(error => {
                console.error("Video loading failed with error : ", error);
            });
    }

    public beforeDestroy() {
        if (this.player) {
            this.player.destroy();
        }
    }
}
